import React from 'react'
import { H2 } from '@/common/ui'
import { BundleCard } from '@/bundles/bundleCard'
import { INVEST_COPY } from '@/locales/en'
import { useFetchBundles } from '@/trading/tradingQueries'

const SKELETON_CARDS = [1, 2]

const BundleCards: React.FC = () => {
    const { data: bundles, isLoading } = useFetchBundles()

    return (
        <div className="w-full self-stretch inline-flex flex-col justify-start items-start min-w-0 gap-6">
            <div className="self-stretch inline-flex flex-col justify-start items-start gap-4">
                <H2 className="justify-center text-black text-3xl md:text-3xl font-normal font-['Serious_Sans'] leading-10 mb-0">
                    {INVEST_COPY.bundlesTitle}
                </H2>
                <div className="self-stretch justify-start text-content-secondary text-sm font-normal font-['Inter'] leading-5">
                    {INVEST_COPY.bundlesDescription}
                </div>
            </div>

            <div className="w-full min-w-0 overflow-x-auto overflow-y-hidden">
                <div className="flex min-w-full flex-nowrap items-stretch gap-3 min-h-[300px]">
                    {isLoading
                        ? SKELETON_CARDS.map((i) => (
                              <div key={i} className="min-w-[300px] basis-[300px] flex-1 self-stretch flex">
                                  <BundleCard key={i} />
                              </div>
                          ))
                        : bundles?.map((bundle) => (
                              <div key={bundle.slug} className="min-w-[300px] basis-[300px] flex-1 self-stretch flex">
                                  <BundleCard bundle={bundle} />
                              </div>
                          ))}
                </div>
            </div>
        </div>
    )
}

export default BundleCards
